import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-farmacia',
  standalone: true,
  imports: [],
  templateUrl: '../../movi-link/hero-pages/hero-movi-link.component.html',
  styleUrl: './hero-farmacia.component.css'
})
export class HeroFarmaciaComponent {

  title = 'Familink';
  subtitle1 = 'Tu farmacia';
  subtitle2 = 'cerca de ti';
  callToAction = 'Contáctanos';
  routeImageMain = 'assets/img/farmacia/imagenFarmacia.svg';

}
